'use strict'

const { isSameRecord } = require('./records')
const recordStoreServiceCreator = require('./service')

module.exports = { isSameRecord, recordStoreServiceCreator }



// WEBPACK FOOTER //
// ./record-store/index.js